// ----------------------------------------------------------------------

export enum AutoHideDuration {
  durationThreeSeconds = 3000,
  durationFiveSeconds = 5000
}
